module.exports = __webpack_public_path__ + "img/23.22566bd5.jpg";